<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'BuildUserCountStat',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        color: ['#1E90FF', 'red', '#FF8C00'],
        title: {
          text: '购买统计'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['购买人数', '购买率', '下单成功率'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          name: '人数',
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        },
        {
          name: '购买率',
          type: 'value',
          axisLabel: {
            formatter: '{value}%' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '购买人数',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '购买率',
            data: [],
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '下单成功率',
            data: [],
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
        ]
      }
    },
    refresh(data) {
      const time = []
      const shareUser = []
      const rewardUser = []
      const playOrderRate = []
      for (const i in data) {
        time.push(dateStrTodate(data[i].date))
        shareUser.push(data[i].order)
        rewardUser.push(data[i].order_rate)
        playOrderRate.push(data[i].play_order_rate)
      }
      this.option.xAxis.data = time
      this.option.series[0].data = shareUser
      this.option.series[1].data = rewardUser
      this.option.series[2].data = playOrderRate
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
